import { Base } from './base-model';

export class ClassActivity extends Base {
    name: string
    activityCount: number
}
